<template lang='pug' src='./modal.pug'></template>

<script>
export default {
  methods: {
    closeModal () {
      this.$store.dispatch('VIEW_SHOWMODAL', false)
      this.$store.dispatch('VIEW_MODALCONTENT', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// modal.vue?9dc7c17e